if (!customElements.get('ludus-shapewear-list')) {
  customElements.define('ludus-shapewear-list', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.enhanced === 'true') return;
      const content = this.querySelector('[data-list-content]');
      const richText = content?.querySelector(':scope > .metafield-rich_text_field');
      const button = this.querySelector('button[aria-controls]');
      if (!richText || !button || richText.children.length !== 1) return;
      const list = richText.firstElementChild;
      if (!list.matches('ul, ol')) return;
      const items = Array.from(list.children);
      if (items.length <= 3 || items.some(item => item.tagName !== 'LI')) return;
      const additionalItems = items.slice(3);
      const more = button.querySelector('[data-show-more]');
      const less = button.querySelector('[data-show-less]');
      const setExpanded = expanded => {
        additionalItems.forEach(item => { item.hidden = !expanded; });
        button.setAttribute('aria-expanded', String(expanded));
        button.setAttribute('aria-label', expanded ? button.dataset.lessLabel : button.dataset.moreLabel);
        more.hidden = expanded;
        less.hidden = !expanded;
      };
      button.addEventListener('click', () => setExpanded(button.getAttribute('aria-expanded') !== 'true'));
      setExpanded(false);
      button.hidden = false;
      this.dataset.enhanced = 'true';
    }
  });
}
